import { render } from "./IndexTabs.vue?vue&type=template&id=7ea688fc&scoped=true&ts=true"
import script from "./IndexTabs.vue?vue&type=script&lang=ts"
export * from "./IndexTabs.vue?vue&type=script&lang=ts"

import "./IndexTabs.vue?vue&type=style&index=0&id=7ea688fc&scoped=true&lang=scss"

import exportComponent from "/app/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea688fc"]])

export default __exports__